import { API_BASE_URL, API_PATHS, } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class ProfileService {

    static getProfile(item) {

        let api = `${API_BASE_URL}${API_PATHS.getProfile}`;

        const params = new URLSearchParams();

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static getDashboardSummary(item) {

        let api = `${API_BASE_URL}${API_PATHS.getDashboardSummary}`;

        return axiosInstance.get(api, item);
    }

    static getDirectReferrals(item) {
        const api = `${API_BASE_URL}${API_PATHS.getDirectReferrals}`;

        return axiosInstance.get(api, {
            params: item,
        });
    }

    static getUsers(item = {}) {
        const api = `${API_BASE_URL}${API_PATHS.getUsers}`;

        const params = {
            page: item?.page || 1,
            limit: item?.limit || 10,
        };

        if (item?.search) {
            params.search = item.search;
        }

        if (item?.userId) {
            params.userId = item.userId;
        }

        if (item?.fromDate) {
            params.fromDate = item.fromDate;
        }

        if (item?.toDate) {
            params.toDate = item.toDate;
        }

        if (item?.id) {
            params.id = item.id;
        }


        if (item?.referredBy) {
            params.referredBy = item.referredBy;
        }

        return axiosInstance.get(api, {
            params,
        });
    }
    static getJoiningPaymentList(data = {}) {
        const api = `${API_BASE_URL}${API_PATHS.getJoiningPaymentList}`;

        const params = {
            status: data?.status || "PENDING",
            page: data?.page || 1,
            limit: data?.limit || 10,
        };

        if (data?.userId?.trim()) {
            params.userId = data.userId.trim();
        }

        if (data?.search?.trim()) {
            params.search = data.search.trim();
        }

        if (data?.activationType?.trim()) {
            params.activationType = data.activationType.trim();
        }

        return axiosInstance.get(api, {
            params,
        });
    }


    static getSelfActivateWallets(data = {}) {
        const api = `${API_BASE_URL}${API_PATHS.getSelfActivateWallets}`;

        const params = {
            page: data?.page || 1,
            limit: data?.limit || 10,
        };

        // Include status only when explicitly provided.
        // Otherwise, let the backend return its default results.
        if (data?.status?.trim()) {
            params.status = data.status.trim();
        }

        if (data?.userId?.trim()) {
            params.userId = data.userId.trim();
        }

        if (data?.search?.trim()) {
            params.search = data.search.trim();
        }

        return axiosInstance.get(api, { params });
    }

    static getSelfActivationTransferTransactions(data = {}) {
        const api = `${API_BASE_URL}${API_PATHS.getSelfActivationTransferTransactions}`;

        const params = {
            page: data?.page || 1,
            limit: data?.limit || 10,
        };

        // Include status only when explicitly provided.
        // Otherwise, let the backend return its default results.
        if (data?.status?.trim()) {
            params.status = data.status.trim();
        }

        if (data?.userId?.trim()) {
            params.userId = data.userId.trim();
        }

        if (data?.search?.trim()) {
            params.search = data.search.trim();
        }

        return axiosInstance.get(api, { params });
    }

    static transferSelfActivationAmountToCompanyWallet(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.transferSelfActivationAmountToCompanyWallet}`;
        return axiosInstance
            .post(api, data)

    }

    static approveRejectJoiningPayment(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.approveRejectJoiningPayment}`;
        return axiosInstance
            .post(api, data)

    }

    static edituserprofile(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.edituserprofile}`;
        return axiosInstance
            .put(api, data)

    }
    static changePassword(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.changePassword}`;
        return axiosInstance
            .put(api, data)

    }

    static getQr(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.getQr}`;
        return axiosInstance
            .get(api, data)

    }

    static editQr(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editQr}`;
        return axiosInstance
            .put(api, data)

    }


    static editProfessionalDetails(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.updateProfessionalDetails}`;
        return axiosInstance
            .put(api, data)

    }


    static deleteProfile(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteProfile}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default ProfileService;
